import store from '../../init/store.js'
import {getQueryVariable} from '../../helpers/get-query-variable.js'
import {getWinningTeam} from '../lifecycle/get-dead-teams.js'
import {getBattleType} from '../get-battle-type.js'

export function writeTrackingReportToDatabase() {

  let user = window.firebase.auth().currentUser;
    if (user) {
      getFinalReport(turnReports => {
        const reportsRef = window.firebase.database().ref(`reports`);
        const reportPayload = {

          crewNames: store.getState().matchmaking.crewNames,
          clientIds: getClients(),

          battleType: getBattleType(),
          isDevScenarioMode: Boolean(getQueryVariable("dev")),
          winningTeamId: getWinningTeam(),

          duration: getDurationModel(),

          turns: {
            ...turnReports //t1,t2,t3, etc.
          }
        };

        reportsRef.push(reportPayload)
      })
    } else {
      console.warn('not reporting data because this user is not logged in')
    }
}

//Return description of starting and ending timestamps of this battle
function getDurationModel() {
  const battleStartTimestamp = store.getState().battle.battleStartTimestamp;

  //If we have a starting value (we should, but who knows?)
  if (battleStartTimestamp) {
    return {
      wasDurationTracked: true,
      battleStartTimestamp: battleStartTimestamp,
      battleEndTimestamp: Date.now()
    }
  }

  //Otherwise, save an error state
  return {
    wasDurationTracked: false
  }
}

//Return an object of all client Ids in this battle
function getClients() {
  const isMultiplayerMode = store.getState().battle.isMultiplayerMode;

  //If single player, simply return the user's logged in ID
  //Otherwise, everybody will be "main"
  if (!isMultiplayerMode) {
    return {
      [`client_${store.getState().crew.logggedInUserId}`]: true
    }
  }

  //If multiplayer, get only the `client_` ids. (Not bots or buddies)
  const initialCombatantData = store.getState().matchmaking.initialCombatantData;
  let payload = {};
  Object.keys(initialCombatantData).forEach(key => {
    if (key.match(/^client_/)) {
      payload[key] = true;
    }
  });
  return payload;


}


function getFinalReport(callback) {

  //For multiplayer, we need to retrieve the true result data from Firebase.
  //Because each client captures their own processed piece.
  if (store.getState().battle.isMultiplayerMode ) {
    //Only one client will submit this!
    //Whichever client processed the state.

    window.roomRef.child("turnReporting").once("value", snap => {
      //Call the callback with our retrieved data
      callback(snap.val())
    })
  }

  //Return Synchronous result. No need to wait
  callback( store.getState().battle.turnReporting );
}


// WEBPACK FOOTER //
// ./src/battle/analysis/write-tracking-report-to-database.js